export default "__VITE_ASSET__wmzcHqvG__"